import { Component } from '@theme/component';

// Compatibility adapter for any remaining Horizon discount markup.
class CartDiscount extends Component {
  applyDiscount = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const input = event.target.querySelector('[name="discount"]');
    if (input) window.NemoCart?.discount(input.value);
  };
  removeDiscount = (event) => {
    if (event instanceof KeyboardEvent && !['Enter', ' '].includes(event.key)) return;
    const code = event.target.closest('[data-discount-code]')?.dataset.discountCode;
    if (!code) return;
    event.preventDefault();
    event.stopPropagation();
    window.NemoCart?.discount(code, true);
  };
}
if (!customElements.get('cart-discount-component')) customElements.define('cart-discount-component', CartDiscount);
